


import React, { useEffect, useState } from "react";
import {
  Box, Typography, Card, CardContent, Button, Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Rating, Container, MenuItem, Select, FormControl, InputLabel, IconButton,
  CircularProgress, Chip, LinearProgress, Paper, Grid, Table, TableBody, TableCell, 
  TableContainer, TableHead, TableRow, ToggleButton, ToggleButtonGroup,  Divider
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DescriptionIcon from "@mui/icons-material/Description";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";
import CloseIcon from "@mui/icons-material/Close";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewListIcon from "@mui/icons-material/ViewList";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import PaymentIcon from "@mui/icons-material/Payment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { fetchUserFromRedis } from "../../HomePage/AuthonticationScreens/Register";
import CustomDialog from "../../../CustomDialog";
import Footer from "../../Common/Footer";
import EditIcon from "@mui/icons-material/Edit";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { apiRequest } from '../../../fetchSetup';
import { useNavigate } from "react-router-dom";

const MyBookingsScreen = () => {
  const [bookings, setBookings] = useState([]);
  const [user, setUser] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [formData, setFormData] = useState({
    rating: 0,
    comment: "",
    category: "",
    date: "",
    cancellation_reason: "",
    reschedule_reason: ""  
  });
  const [validationDialogOpen, setValidationDialogOpen] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [previewDialog, setPreviewDialog] = useState({ 
    open: false, 
    url: null, 
    type: null, 
    filename: null 
  });
  const [bookingViewMode, setBookingViewMode] = useState('table');
  const [reportViewMode, setReportViewMode] = useState('table');
  const [issuesDialog, setIssuesDialog] = useState({ open: false, booking: null });
  const [expandedIssues, setExpandedIssues] = useState({});
  const BOOKED_SERVICES_API = process.env.REACT_APP_BOOKED_SERVICES_API;
  const complaintsAPI = process.env.REACT_APP_COMPLAINTS_API;
  const feedbackAPI = process.env.REACT_APP_SERVICE_FEEDBACK_API;
  const updateBookingApi = process.env.REACT_APP_UPDATE_BOOKINGS;
  const DOWNLOAD_REPORT_API = process.env.REACT_APP_DOWNLOAD_DIAGNOSTIC_REPORT;
  const navigate = useNavigate();


  const formatTime = (dateString) => {
    if (!dateString) return "N/A";
  
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "Invalid Date";
  
      // Add 5 hours 30 minutes (IST offset)
      date.setHours(date.getHours() + 5);
      date.setMinutes(date.getMinutes() + 30);
  
      return date.toLocaleTimeString("en-IN", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true
      });
    } catch (error) {
      console.error("Error formatting time:", error);
      return "N/A";
    }
  };
  

// Format Date in IST (e.g., "Dec 23, 2025")
const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Invalid Date";
    
    // ✅ Add timeZone: 'Asia/Kolkata' to ensure IST
    return date.toLocaleDateString('en-IN', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'Asia/Kolkata'  // ← THIS IS THE FIX!
    });
  } catch (error) {
    return "N/A";
  }
};

  const formatFileSize = (bytes) => {
    if (!bytes) return "N/A";
    const mb = bytes / (1024 * 1024);
    return mb < 1 ? `${(bytes / 1024).toFixed(1)} KB` : `${mb.toFixed(2)} MB`;
  };

  const getFileIcon = (fileType, size = 40) => {
    if (!fileType) return <InsertDriveFileIcon sx={{ color: '#6B7280', fontSize: size }} />;
    const type = fileType.toLowerCase();
    if (type === 'pdf') return <PictureAsPdfIcon sx={{ color: '#DC2626', fontSize: size }} />;
    if (['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'].includes(type)) {
      return <ImageIcon sx={{ color: '#2563EB', fontSize: size }} />;
    }
    return <InsertDriveFileIcon sx={{ color: '#6B7280', fontSize: size }} />;
  };

  const isImageFile = (fileType) => {
    if (!fileType) return false;
    return ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'].includes(fileType.toLowerCase());
  };
  const convertOffsetISOToLocalInput = (isoString) => {
  if (!isoString) return "";

  const date = new Date(isoString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

  const SINGLE_STATUS_COLOR = { bg: "#DBEAFE", text: "#1D4ED8" };

  const STATUS_COLORS = {
    new: SINGLE_STATUS_COLOR,
    pending: SINGLE_STATUS_COLOR,
    confirmed: SINGLE_STATUS_COLOR,
    "sample-collected": SINGLE_STATUS_COLOR,
    "test-in-progress": SINGLE_STATUS_COLOR,
    "report-ready": SINGLE_STATUS_COLOR,
    "report-delivered": SINGLE_STATUS_COLOR,
    completed: SINGLE_STATUS_COLOR,
    cancelled: SINGLE_STATUS_COLOR,
  };
  
  const DELIVERY_STATUS_STEPS = {
    new: 1,
    pending: 1,
    confirmed: 2,
    "sample_collection_reschedule":1,
    "sample_collection_cancelled":1,
    "sample-collected":2,
    "test-in-progress":2, 
    "rescheduled":1,
    "pending_agent_response":2,
    "agent_assigned":3, 
    "report-ready":3,
    "report-packed":3,
    "report-dispatched":3,
    "report-out-for-delivery":3,
   "report-delivered":4,
   "closed":4, 
   "cancelled":1,
   
   
   
  };


  useEffect(() => {
    const fetchUser = async () => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (!userId || !token) {
        setUser(null);
        setLoading(false);
        return;
      }
      try {
        const userData = await fetchUserFromRedis(userId, token);
        setUser(userData || null);
      } catch (err) {
        console.error("Error fetching user from Redis:", err);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  const fetchBookings = async () => {
    if (!user) return;
    try {
      const params = new URLSearchParams({
        email: user.email,
        phone: user.phone,
      });
      const res = await apiRequest(`${BOOKED_SERVICES_API}?${params}`);
      const data = await res.json();
      if (res.ok) {
        const sortedBookings = (data.bookings || []).sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        setBookings(sortedBookings);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setRefreshing(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchBookings();
    }
  }, [user]);

  const onRefresh = () => {
    setRefreshing(true);
    fetchBookings();
  };

 
  const handleDownloadReport = async (
    bookingId,
    filename,
    originalFilename
  ) => {
    try {
      console.log("Download request:", { bookingId, filename });
  
      const response = await apiRequest(
        `${DOWNLOAD_REPORT_API}/${bookingId}/${filename}`,
        { method: "GET" }
      );
  
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Download failed: ${errorText}`);
      }
  
      const contentType = response.headers.get("content-type");
  
      if (contentType?.includes("application/json")) {
        const data = await response.json();
  
        if (!data.download_url) {
          throw new Error("No download URL received");
        }
  
        // ✅ FORCE DOWNLOAD VIA NEW TAB
        window.open(data.download_url, "_blank");
        return;
      }
  
      const blob = await response.blob();
  
      if (!blob || blob.size === 0) {
        throw new Error("Empty file received");
      }
  
      const url = URL.createObjectURL(blob);
  
      const a = document.createElement("a");
      a.href = url;
      a.download = originalFilename || filename;
      document.body.appendChild(a);
      a.click();
  
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
  
    } catch (err) {
      console.error("Download error:", err);
      setValidationMessage(`Download failed: ${err.message}`);
      setValidationDialogOpen(true);
    }
  };
  

  const handlePreviewReport = async (
    bookingId,
    filename,
    fileType,
    originalFilename
  ) => {
    try {
      console.log("Preview request:", { bookingId, filename });
  
      const response = await apiRequest(
        `${DOWNLOAD_REPORT_API}/${bookingId}/${filename}`,
        { method: "GET" }
      );
  
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Preview failed: ${errorText}`);
      }
  
      const contentType = response.headers.get("content-type");

      if (contentType?.includes("application/json")) {
        const data = await response.json();
  
        if (!data.download_url) {
          throw new Error("No preview URL received");
        }
  
        // ✅ SHOW IN PREVIEW DIALOG (NO DOWNLOAD)
        setPreviewDialog({
          open: true,
          url: data.download_url,
          type: fileType || "unknown",
          filename: originalFilename || filename
        });
  
        return;
      }
  
      const blob = await response.blob();
  
      if (!blob || blob.size === 0) {
        throw new Error("Empty file received");
      }
  
      const previewUrl = URL.createObjectURL(blob);
  
      setPreviewDialog({
        open: true,
        url: previewUrl,
        type: fileType || blob.type,
        filename: originalFilename || filename
      });
  
    } catch (err) {
      console.error("Preview error:", err);
      setValidationMessage(`Preview failed: ${err.message}`);
      setValidationDialogOpen(true);
    }
  };
  

  const handleClosePreview = () => {
    if (previewDialog.url) {
      window.URL.revokeObjectURL(previewDialog.url);
    }
    setPreviewDialog({ open: false, url: null, type: null, filename: null });
  };

  const handleOpenDialog = (type, booking) => {
    setDialogType(type);
    setSelectedBooking(booking);
    setFormData({ rating: 0, comment: "", category: "", date: "", cancellation_reason: "" });
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedBooking(null);
  };


  const now = new Date();
const minDateTime = now.toISOString().slice(0, 16);

// Max date = now + 10 days
const maxDate = new Date();
maxDate.setDate(maxDate.getDate() + 10);
const maxDateTime = maxDate.toISOString().slice(0, 16);


  const handleSubmit = async () => {
    setLoading(true);
    if (!selectedBooking) return;

    if (dialogType === "reschedule") {
      const selectedDate = new Date(formData.date);
    
      if (selectedDate < now || selectedDate > maxDate) {
        setValidationMessage(
          "Please select a date between now and the next 10 days."
        );
        setValidationDialogOpen(true);
        setLoading(false);
        return;
      }
    
      if (!formData.reschedule_reason) {
        setValidationMessage("Please provide a reason for rescheduling!");
        setValidationDialogOpen(true);
        setLoading(false);
        return;
      }
    }
    
    if (dialogType === "cancel" && !formData.cancellation_reason) {
      setValidationMessage("Please provide a reason for cancellation!");
      setValidationDialogOpen(true);
      setLoading(false);
      return;
    }
    
    if (dialogType === "feedback" && !formData.rating) {
      setValidationMessage("Please select a rating!");
      setValidationDialogOpen(true);
      setLoading(false);
      return;
    }

    if (dialogType === "complaint" && !formData.category) {
      setValidationMessage("Please select a category!");
      setValidationDialogOpen(true);
      setLoading(false);
      return;
    }

    let endpoint = "";
    let payload = {};
    let method = "POST";

    if (dialogType === "complaint") {
      endpoint = `${complaintsAPI}/${selectedBooking.booking_id}`;
      payload = {
        resident_id: user.user_id,
        rating: formData.rating,
        comment: formData.category === "other" ? formData.comment : `${formData.category} - ${formData.comment}`,
        category: formData.category,
        status: "open",
      };
    } else if (dialogType === "reschedule") {
      endpoint = `${updateBookingApi}/${selectedBooking.booking_id}`;
      payload = { date: formData.date,reschedule_reason: formData.reschedule_reason,action: "reschedule" };
      method = "PUT";
    } else if (dialogType === "cancel") {
      endpoint = `${updateBookingApi}/${selectedBooking.booking_id}`;
      payload = { action: "cancel", status: "cancelled", cancellation_reason: formData.cancellation_reason };
      method = "PUT";
    } else {
      endpoint = `${feedbackAPI}/${selectedBooking.booking_id}`;
      payload = { rating: formData.rating, comment: formData.comment };
    }

    try {
      const res = await apiRequest(endpoint, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (res.ok) {
        setValidationMessage(data.message || "Success!");
        setValidationDialogOpen(true);
        handleCloseDialog();
        fetchBookings();
      } else {
        setValidationMessage("Error: " + data.error);
        setValidationDialogOpen(true);
      }
    } catch (err) {
      console.error("Submit error:", err);
      setValidationMessage("Failed to submit. Please try again.");
      setValidationDialogOpen(true);
    } finally {
      setLoading(false);
    }
  };
  const handleOpenDetails = (booking) => {
  navigate(`/booking-details/${booking.booking_id}`, {
    state: { booking }
  });
};

  const getStatusColor = (status) => {
    return STATUS_COLORS[status?.toLowerCase()] || { bg: "#E0F4F5", text: "#6B7280" };
  };

  const renderDeliveryProgress = (status) => {
    const currentStep = DELIVERY_STATUS_STEPS[status?.toLowerCase()] || 1;
    const progress = (currentStep / 4) * 100;

    return (
      <Box sx={{ mb: 2 }}>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: 6,
            borderRadius: 3,
            bgcolor: "#E5E7EB",
            "& .MuiLinearProgress-bar": {
              bgcolor: "#006D77",
              borderRadius: 3,
            },
          }}
        />
        <Typography sx={{ fontSize: 11, color: "#6B7280", fontWeight: 600, mt: 0.5 }}>
          {status === "completed" || status === "report-delivered" ? "Service Completed" : status === "cancelled" ? "Booking Cancelled" : `Step ${currentStep} of 4`}
        </Typography>
      </Box>
    );
  };

  const renderReportsCardView = (reports, bookingId) => (
    <Grid container spacing={2}>
      {reports.map((report, idx) => (
        <Grid item xs={12} sm={6} md={4} key={idx}>
          <Card
            elevation={2}
            sx={{
              height: '100%',
              border: "2px solid #E5E7EB",
              borderRadius: 3,
              transition: "all 0.3s",
              "&:hover": {
                borderColor: "#006D77",
                boxShadow: "0 8px 24px rgba(0,109,119,0.2)",
                transform: "translateY(-4px)"
              }
            }}
          >
            <CardContent sx={{ p: 2.5, textAlign: 'center' }}>
              <Box sx={{ mb: 2 }}>
                {getFileIcon(report.file_type, 56)}
              </Box>
              
              <Typography 
                variant="body2" 
                fontWeight="700" 
                sx={{ mb: 1, color: '#111827' }}
                noWrap
                title={report.original_filename || report.filename}
              >
                {report.original_filename || report.filename}
              </Typography>
              
              <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                📅 {formatDate(report.uploaded_at)}
              </Typography>
              
              <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                💾 {formatFileSize(report.file_size)}
              </Typography>
              
              <Divider sx={{ my: 1.5 }} />
              
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  size="small"
                  variant="outlined"
                  fullWidth
                  startIcon={<VisibilityIcon fontSize="small" />}
                  onClick={() => handlePreviewReport(
                    bookingId, 
                    report.filename, 
                    report.file_type,
                    report.original_filename
                  )}
                  sx={{
                    borderColor: "#006D77",
                    color: "#006D77",
                    fontSize: 11,
                    fontWeight: 600,
                    textTransform: "none",
                    "&:hover": {
                      borderColor: "#005761",
                      bgcolor: "rgba(0, 109, 119, 0.08)"
                    }
                  }}
                >
                  Preview
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  fullWidth
                  startIcon={<DownloadIcon fontSize="small" />}
                  onClick={() => handleDownloadReport(
                    bookingId, 
                    report.filename,
                    report.original_filename
                  )}
                  sx={{
                    bgcolor: "#006D77",
                    fontSize: 11,
                    fontWeight: 600,
                    textTransform: "none",
                    "&:hover": { bgcolor: "#005761" }
                  }}
                >
                  Download
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  const renderReportsTableView = (reports, bookingId) => (
    <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #E5E7EB', borderRadius: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ bgcolor: '#F9FAFB' }}>
            <TableCell sx={{ fontWeight: 700, color: '#374151' }}>File</TableCell>
            <TableCell sx={{ fontWeight: 700, color: '#374151' }}>Upload Date</TableCell>
            <TableCell sx={{ fontWeight: 700, color: '#374151' }}>Size</TableCell>
            <TableCell sx={{ fontWeight: 700, color: '#374151' }}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {reports.map((report, idx) => (
            <TableRow 
              key={idx}
              sx={{ 
                '&:hover': { bgcolor: '#F0F9FF' },
                '&:last-child td': { border: 0 }
              }}
            >
              <TableCell>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  {getFileIcon(report.file_type, 32)}
                  <Box>
                    <Typography 
                      variant="body2" 
                      fontWeight="600"
                      sx={{ color: '#111827' }}
                      title={report.original_filename || report.filename}
                    >
                      {(report.original_filename || report.filename).length > 30 
                        ? (report.original_filename || report.filename).substring(0, 30) + '...'
                        : (report.original_filename || report.filename)
                      }
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {report.file_type?.toUpperCase() || 'FILE'}
                    </Typography>
                  </Box>
                </Box>
              </TableCell>
              <TableCell>
                <Typography variant="body2">
                  {formatDate(report.uploaded_at)}
                </Typography>
              </TableCell>
              <TableCell>
                <Chip 
                  label={formatFileSize(report.file_size)}
                  size="small"
                  sx={{ 
                    bgcolor: '#F3F4F6',
                    color: '#6B7280',
                    fontWeight: 600,
                    fontSize: 11,pointerEvents:"none"
                  }}
                />
              </TableCell>
              <TableCell>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <IconButton
                    size="small"
                    onClick={() => handlePreviewReport(
                      bookingId, 
                      report.filename, 
                      report.file_type,
                      report.original_filename
                    )}
                    sx={{ 
                      bgcolor: '#DBEAFE',
                      '&:hover': { bgcolor: '#BFDBFE' }
                    }}
                  >
                    <VisibilityIcon fontSize="small" sx={{ color: '#2563EB' }} />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => handleDownloadReport(
                      bookingId, 
                      report.filename,
                      report.original_filename
                    )}
                    sx={{ 
                      bgcolor: '#D1FAE5',
                      '&:hover': { bgcolor: '#A7F3D0' }
                    }}
                  >
                    <DownloadIcon fontSize="small" sx={{ color: '#059669' }} />
                  </IconButton>
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
  const getCombinedIssues = (booking) => {
    if (!booking) return [];
    
    const issues = [];
    
    // Handle delivery_issues
    if (booking.delivery_issues && Array.isArray(booking.delivery_issues)) {
      booking.delivery_issues.forEach((issue, index) => {
        issues.push({
          ...issue,
          issue_id: issue.issue_id || `DI-${booking.booking_id}-${index}`,
          source: 'delivery_issue',
          issue_category: 'Delivery Issue',
          issue_type: issue.issue_type || 'delivery_issue',
          description: issue.description || 'No description',
          reported_at: issue.reported_at || new Date().toISOString(),
          reported_by: issue.reported_by || 'System',
          status: issue.status || 'open'
        });
      });
    }
    
    // Handle collection_failures - THIS IS THE KEY FIX!
    if (booking.collection_failures && Array.isArray(booking.collection_failures)) {
      booking.collection_failures.forEach((failure, index) => {
        const issueId = failure.issue_id || `CF-${booking.booking_id}-${index}`;
        
        // Build description from MongoDB fields
        const description = failure.failure_details || 
                           `${failure.failure_reason || 'Collection Failed'}: ${failure.additional_notes || 'See details'}`;
        
        issues.push({
          issue_id: issueId,
          issue_type: failure.failure_type || 'collection_failure',
          description: description,
          reported_at: failure.reported_at || new Date().toISOString(),
          reported_by: failure.reported_by || 'Collector',
          status: failure.status || 'open',
          photo_url: failure.photo_url || null,
          source: 'collection_failure',
          issue_category: 'Sample Collection Failure',
          
          // Keep all MongoDB fields
          failure_reason: failure.failure_reason,
          failure_details: failure.failure_details,
          can_reschedule: failure.can_reschedule,
          suggested_reschedule_time: failure.suggested_reschedule_time,
          patient_available: failure.patient_available,
          address_issue: failure.address_issue,
          additional_notes: failure.additional_notes
        });
      });
    }
    
    // Sort by date
    issues.sort((a, b) => new Date(b.reported_at) - new Date(a.reported_at));
    
    return issues;
  };

  const canModifyBooking = (status) => {
    const blockedStatuses = [
      "agent_assigned", 
      "sample-collected",
      "test-in-progress", 
      "report-ready",
      "report-packed",
      "report-dispatched",
      "report-out-for-delivery",
      "report-delivered",
      "closed", 
      "cancelled",
      "rescheduled",
      "pending_agent_response",
      "sample_collection_reschedule",
      "sample_collection_cancelled"
    ];
  
    return !blockedStatuses.includes(status);
  };
  

  const renderBookingCard = (booking) => {
    const statusInfo = getStatusColor(booking.status);
    const hasReports = booking.diagnostic_reports && booking.diagnostic_reports.length > 0;
  
    const issuesCount = getCombinedIssues(booking).length;
    return (

      <Card
      elevation={3}
      sx={{
        borderRadius: 3,
        width: 700,       
        flexGrow: 1,        
        display: "flex",
        flexDirection: "column",
        height: "auto",        
        transition: "all 0.3s",
        "&:hover": { 
          transform: "translateY(-4px)",
          boxShadow: "0 12px 24px rgba(0,109,119,0.15)"
        },
        border: "1px solid #E5E7EB"
      }}
    >
        <CardContent sx={{ p: 2.5 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
            <Box sx={{ flex: 1 }}>
              <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#111827", mb: 0.5 }}>
                {booking.service_type}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                <Chip
                  icon={<CalendarTodayIcon sx={{ fontSize: 14 }} />}
                  label={formatDate(booking.date)}
                  size="small"
                  sx={{ fontSize: 11, height: 24, bgcolor: "#F3F4F6",pointerEvents:"none" }}
                />
                <Chip
                    icon={<AccessTimeIcon sx={{ fontSize: 14 }} />}
                    label={formatTime(booking.date)}
                    size="small"
                    sx={{ 
                      fontSize: 11, 
                      height: 24, 
                      bgcolor: "#F3F4F6",
                      pointerEvents: "none" 
                    }}
                  />
              </Box>
            </Box>
            <Chip
              label={booking.status}
              sx={{
                bgcolor: statusInfo.bg,
                color: statusInfo.text,
                fontWeight: 700,
                fontSize: 11,
                height: 26,
                textTransform: "capitalize",pointerEvents:"none"
              }}
            />
          </Box>

          {booking.status !== "cancelled" && renderDeliveryProgress(booking.status)}

          <Grid container spacing={1.5} sx={{ mb: 2 }}>
            <Grid item xs={6}>
              <Paper elevation={0} sx={{ p: 1.5, bgcolor: "#F9FAFB", borderRadius: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                  <PersonIcon sx={{ fontSize: 16, color: "#006D77" }} />
                  <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#6B7280" }}>
                    PATIENT
                  </Typography>
                </Box>
                <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#111827" }}>
                  {booking.guest_name}
                </Typography>
                <Typography sx={{ fontSize: 11, color: "#6B7280" }}>
                  {booking.age}y • {booking.gender}
                </Typography>
              </Paper>
            </Grid>

            <Grid item xs={6}>
  <Paper elevation={0} sx={{ p: 1.5, bgcolor: "#F9FAFB", borderRadius: 2 }}>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
      <PaymentIcon sx={{ fontSize: 16, color: "#006D77" }} />
      <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#6B7280" }}>
        PAYMENT
      </Typography>
    </Box>
    
    {/* Show original amount if discounts exist */}
    {(booking.subscription_discount > 0 || booking.promo_discount > 0) && (
      <Typography sx={{ 
        fontSize: 12, 
        color: "#9CA3AF", 
        textDecoration: "line-through" 
      }}>
        ₹{(
          parseFloat(booking.payment?.amount || 0) + 
          parseFloat(booking.subscription_discount || 0) + 
          parseFloat(booking.promo_discount || 0)
        ).toFixed(2)}
      </Typography>
    )}
    
    {/* Final amount */}
    <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#006D77" }}>
      ₹{booking.payment?.amount}
    </Typography>
    
    {/* Payment status */}
    <Chip
      label={booking.payment?.status}
      size="small"
      sx={{
        fontSize: 10,
        height: 20,
        bgcolor: booking.payment?.status === 'paid' ? '#D1FAE5' : '#FEF3C7',
        color: booking.payment?.status === 'paid' ? '#059669' : '#D97706',
        fontWeight: 600,
        textTransform: 'capitalize',
        pointerEvents: "none",
        mt: 0.5
      }}
    />
    
    {/* Subscription discount */}
    {booking.subscription_discount > 0 && (
      <Typography sx={{ 
        fontSize: 10, 
        color: "#7C3AED", 
        mt: 0.5,
        display: "flex",
        alignItems: "center",
        gap: 0.5
      }}>
        🎉 Sub: -₹{parseFloat(booking.subscription_discount).toFixed(2)}
      </Typography>
    )}
    
    {/* Promo discount */}
    {booking.promo_discount > 0 && (
      <Typography sx={{ 
        fontSize: 10, 
        color: "#10B981", 
        mt: 0.5,
        display: "flex",
        alignItems: "center",
        gap: 0.5
      }}>
        🏷️ {booking.promo_code}: -₹{parseFloat(booking.promo_discount).toFixed(2)}
      </Typography>
    )}
  </Paper>
</Grid>

</Grid>

{/* NEW SECTION: Discount Details */}
{(booking.subscription_discount > 0 || booking.promo_discount > 0) && (
  <Paper elevation={0} sx={{ p: 1.5, bgcolor: "#F0F9FF", borderRadius: 2, border: "1px solid #DDD6FE", mb: 2 }}>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
      <LocalOfferIcon sx={{ fontSize: 16, color: "#7C3AED" }} />
      <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#7C3AED" }}>
        DISCOUNTS APPLIED
      </Typography>
    </Box>
    
    {booking.subscription_discount > 0 && (
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 0.5 }}>
        <Typography sx={{ fontSize: 11, color: "#6B7280" }}>
          🎉 Subscription Discount
        </Typography>
        <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#7C3AED" }}>
          -₹{parseFloat(booking.subscription_discount).toFixed(2)}
        </Typography>
      </Box>
    )}
    
    {booking.promo_discount > 0 && (
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography sx={{ fontSize: 11, color: "#6B7280" }}>
          🏷️ Promo Code: <strong>{booking.promo_code}</strong>
        </Typography>
        <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#10B981" }}>
          -₹{parseFloat(booking.promo_discount).toFixed(2)}
        </Typography>
      </Box>
    )}
    
    <Divider sx={{ my: 1 }} />
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#111827" }}>
        Total Savings
      </Typography>
      <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#059669" }}>
        -₹{(
          parseFloat(booking.subscription_discount || 0) + 
          parseFloat(booking.promo_discount || 0)
        ).toFixed(2)}
      </Typography>
    </Box>
  </Paper>
)}

<Paper elevation={0} sx={{ p: 1.5, bgcolor: "#F0F9FF", borderRadius: 2, mb: 2 }}>
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
    <LocalHospitalIcon sx={{ fontSize: 16, color: "#006D77" }} />
              <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#6B7280" }}>
                TESTS/SERVICES
              </Typography>
            </Box>
            <Typography sx={{ fontSize: 12, color: "#374151" }}>
              {booking.diagnostic_tests || 'N/A'}
            </Typography>
            <Typography sx={{ fontSize: 12, color: "#374151" }}>
                 <strong>Reschedule Reason:</strong>{booking.reschedule_reason || "N/A"}
            </Typography>
          </Paper>


          {hasReports && (
            <Paper elevation={0} sx={{ p: 1.5, borderRadius: 2, mb: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <DescriptionIcon sx={{ fontSize: 18, color: "#D97706" }} />
                  <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#D97706" }}>
                    Reports ({booking.diagnostic_reports.length})
                  </Typography>
                </Box>
                <ToggleButtonGroup
                  value={reportViewMode}
                  exclusive
                  onChange={(e, newMode) => {
                    if (newMode !== null) setReportViewMode(newMode);
                  }}
                  size="small"
                  sx={{ height: 24 }}
                >
                  <ToggleButton value="card" sx={{ px: 1, py: 0.25, fontSize: 10 }}>
                    <ViewModuleIcon sx={{ fontSize: 14 }} />
                  </ToggleButton>
                  <ToggleButton value="table" sx={{ px: 1, py: 0.25, fontSize: 10 }}>
                    <ViewListIcon sx={{ fontSize: 14 }} />
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
              {reportViewMode === 'card' 
                ? renderReportsCardView(booking.diagnostic_reports, booking.booking_id)
                : renderReportsTableView(booking.diagnostic_reports, booking.booking_id)
              }
            </Paper>
          )}

          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button
                size="small"
                variant="outlined"
                fullWidth
                onClick={() => handleOpenDialog("feedback", booking)}
                sx={{
                  borderColor: "#006D77",
                  color: "#006D77",
                  fontSize: 11,
                  fontWeight: 600,
                  textTransform: "none",
                  py: 0.75,
                  "&:hover": { borderColor: "#005761", bgcolor: "rgba(0,109,119,0.08)" }
                }}
              >
                 Feedback
              </Button>
            </Grid>

            {canModifyBooking(booking.status) && (
                <Grid item xs={6}>
                  <Button
                    size="small"
                    variant="outlined"
                    fullWidth
                    onClick={() => handleOpenDialog("reschedule", booking)}
                    sx={{
                      borderColor: "#006D77",
                      color: "#006D77",
                      fontSize: 11,
                      fontWeight: 600,
                      textTransform: "none",
                      py: 0.75,
                      "&:hover": {
                        borderColor: "#005761",
                        bgcolor: "rgba(0,109,119,0.08)"
                      }
                    }}
                  >
                    Reschedule
                  </Button>
                </Grid>
              )}

            <Grid item xs={6}>
              <Button
                size="small"
                variant="outlined"
                fullWidth
                onClick={() => handleOpenDialog("complaint", booking)}
                sx={{
                  borderColor: "#006D77",
                  color: "#006D77",
                  fontSize: 11,
                  fontWeight: 600,
                  textTransform: "none",
                  py: 0.75,
                  "&:hover": { borderColor: "#005761", bgcolor: "rgba(0,109,119,0.08)" }
                }}
              >
                 Complaint
              </Button>
            </Grid>
            <Grid item xs={6}>
            {canModifyBooking(booking.status) && (
                <Button
                  size="small"
                  variant="outlined"
                  fullWidth
                  onClick={() => handleOpenDialog("cancel", booking)}
                  sx={{
                    borderColor: "#D97706",
                    color: "#D97706",
                    fontSize: 11,
                    fontWeight: 600,
                    textTransform: "none",
                    py: 0.75,
                    "&:hover": { borderColor: "#B45309", bgcolor: "rgba(217,119,6,0.08)" }
                  }}
                >
                   Cancel
                </Button>
              )}
            </Grid>

            {getCombinedIssues(booking).length > 0 && (
              <Grid item xs={6}>
                <Button
                  size="small"
                  variant="outlined"
                  fullWidth
                  onClick={() => setIssuesDialog({ open: true, booking })}                  sx={{
                    borderColor: "#D97706",
                    color: "#D97706",
                    fontSize: 11,
                    fontWeight: 600,
                    textTransform: "none",
                    py: 0.75,
                    "&:hover": { borderColor: "#B45309", bgcolor: "rgba(217,119,6,0.08)" }
                  }}
                >
                   View Issues  ({getCombinedIssues(booking).length})
                  </Button>
                </Grid>
              )}
          </Grid>
          <Typography sx={{ fontSize: 10, color: "#9CA3AF", textAlign: "center", mt: 1.5, fontFamily: 'monospace' }}>
            ID: #{booking.booking_id}
          </Typography>
        </CardContent>
      </Card>
    );
  };

  const renderBookingTable = () => (
    <TableContainer component={Paper} elevation={3} sx={{ borderRadius: 3 }}>
      <Table>
        <TableHead>
          <TableRow sx={{ bgcolor: "#006D77" }}>
            <TableCell sx={{ color: "white", fontWeight: 700, fontSize: 13 }}>Service</TableCell>
            <TableCell sx={{ color: "white", fontWeight: 700, fontSize: 13 }}>Patient</TableCell>
            <TableCell sx={{ color: "white", fontWeight: 700, fontSize: 13 }}>Date & Time</TableCell>
            <TableCell sx={{ color: "white", fontWeight: 700, fontSize: 13 }}>Status</TableCell>
            <TableCell sx={{ color: "white", fontWeight: 700, fontSize: 13 }}>Amount</TableCell>
            <TableCell sx={{ color: "white", fontWeight: 700, fontSize: 13 }}>Discounts</TableCell>
            <TableCell sx={{ color: "white", fontWeight: 700, fontSize: 13 }}>Reports</TableCell>
            <TableCell sx={{ color: "white", fontWeight: 700, fontSize: 13 }}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {bookings.filter(b => b.status !== "cancelled").map((booking) => {
            const statusInfo = getStatusColor(booking.status);
            const hasReports = booking.diagnostic_reports && booking.diagnostic_reports.length > 0;
            
            return (
              <TableRow 
                key={booking.booking_id}
                onClick={() => handleOpenDetails(booking)}
                sx={{ 
                  '&:hover': { bgcolor: '#F0F9FF' },
                  borderBottom: '1px solid #E5E7EB'
                }}
              >
                <TableCell>
                  <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#111827" }}>
                    {booking.service_type}
                  </Typography>
                  <Typography sx={{ fontSize: 11, color: "#6B7280" }}>
                    #{booking.booking_id}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#111827" }}>
                    {booking.guest_name}
                  </Typography>
                  <Typography sx={{ fontSize: 11, color: "#6B7280" }}>
                    {booking.age}y • {booking.gender}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#111827" }}>
                    {formatDate(booking.date)}
                  </Typography>
                  <Typography sx={{ fontSize: 11, color: "#6B7280" }}>
                    {formatTime(booking.date)}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Chip
                    label={booking.status}
                    size="small"
                    sx={{
                      bgcolor: statusInfo.bg,
                      color: statusInfo.text,
                      fontWeight: 700,
                      fontSize: 11,
                      textTransform: "capitalize",pointerEvents:"none"
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#006D77" }}>
                    ₹{booking.payment?.amount}
                  </Typography>
                  <Chip
                    label={booking.payment?.status}
                    size="small"
                    sx={{
                      fontSize: 10,
                      height: 18,
                      bgcolor: booking.payment?.status === 'paid' ? '#D1FAE5' : '#FEF3C7',
                      color: booking.payment?.status === 'paid' ? '#059669' : '#D97706',
                      fontWeight: 600,
                      textTransform: 'capitalize',pointerEvents:"none"
                    }}
                  />
                </TableCell>

                <TableCell>
                {(booking.subscription_discount > 0 || booking.promo_discount > 0) ? (
                  <Box>
                    {booking.subscription_discount > 0 && (
                      <Chip
                        label={`Sub: -₹${parseFloat(booking.subscription_discount).toFixed(2)}`}
                        size="small"
                        sx={{
                          fontSize: 10,
                          height: 18,
                          bgcolor: '#F3E8FF',
                          color: '#7C3AED',
                          fontWeight: 600,
                          mb: 0.5,
                          pointerEvents: "none",
                          display: "block"
                        }}
                      />
                    )}
                    {booking.promo_discount > 0 && (
                      <Chip
                        label={`${booking.promo_code}: -₹${parseFloat(booking.promo_discount).toFixed(2)}`}
                        size="small"
                        sx={{
                          fontSize: 10,
                          height: 18,
                          bgcolor: '#D1FAE5',
                          color: '#059669',
                          fontWeight: 600,
                          pointerEvents: "none"
                        }}
                      />
                    )}
                  </Box>
                ) : (
                  <Typography sx={{ fontSize: 11, color: "#9CA3AF" }}>No discounts</Typography>
                )}
              </TableCell>
                <TableCell>
                  {hasReports ? (
                    <Chip
                      label={`${booking.diagnostic_reports.length} files`}
                      size="small"
                      icon={<DescriptionIcon sx={{ fontSize: 14 }} />}
                      sx={{ bgcolor: "#FEF3C7", color: "#D97706", fontWeight: 600, fontSize: 11 ,pointerEvents:"none"}}
                    />
                  ) : (
                    <Typography sx={{ fontSize: 11, color: "#9CA3AF" }}>No reports</Typography>
                  )}
                </TableCell>
                <TableCell>
                  <Box sx={{ display: "flex", gap: 0.5 }}>
                    <IconButton
                      size="small"
                      onClick={(e) => {e.stopPropagation();   handleOpenDialog("feedback", booking)}}
                      sx={{ bgcolor: "transparent", '&:hover': { bgcolor: "#BFDBFE" } }}
                      title="Feedback"
                    >
                      <EditIcon sx={{ fontSize: 20, color: "#555" }} />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleOpenDialog("reschedule", booking)}
                      sx={{ '&:hover': { bgcolor: "#C7D2FE" } }}
                      title="Reschedule"
                    >
                      <EventRepeatIcon sx={{ fontSize: 20, color: "#555" }} />
                    </IconButton>
                    {booking.status !== "cancelled" && (
                      <IconButton
                        size="small"
                        onClick={() => handleOpenDialog("cancel", booking)}
                        sx={{  '&:hover': { bgcolor: "#FECACA" } }}
                        title="Cancel"
                      >
                        <CloseIcon sx={{ fontSize: 20, color: "#555" }} />
                      </IconButton>
                    )}
                  </Box>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <>
    <Box sx={{ minHeight: "100vh", bgcolor: "#F9FAFB", pb: 8 }}>
      {/* Header */}


        <Paper elevation={2} sx={{ bgcolor: "#fff", mb: 3 }}>
          <Container maxWidth="lg">
            <Box
              sx={{
                py: { xs: 1.5, sm: 2, md: 3 },
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
              }}
            >
              {/* Back Button */}
              <IconButton
                onClick={() => window.history.back()}
                sx={{
                  backgroundColor: "white",
                  boxShadow: 1,
                  flexShrink: 0,
                  "&:hover": { backgroundColor: "#f5f5f5" },
                }}
              >
                <ArrowBackIcon />
              </IconButton>

              {/* Title */}
              <Typography
                variant="h4"
                sx={{
                  color: "#006D77",
                  fontWeight: 600,
                  fontSize: { xs: "1rem", sm: "1.4rem", md: "2rem" },
                  textAlign: "center",
                  flex: 1,
                }}
              >
                My Booked Services
              </Typography>

              {/* Right Controls */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: { xs: 0.5, sm: 1 },
                  flexShrink: 0,
                }}
              >
                <ToggleButtonGroup
                  value={bookingViewMode}
                  exclusive
                  onChange={(e, newMode) => {
                    if (newMode !== null) setBookingViewMode(newMode);
                  }}
                  size="small"
                  sx={{ height: { xs: 30, sm: 36 } }}
                >
                  <ToggleButton
                    value="card"
                    sx={{
                      px: { xs: 1, sm: 2 },
                      textTransform: "none",
                      fontSize: { xs: 11, sm: 13 },
                    }}
                  >
                    <ViewModuleIcon fontSize="small" sx={{ mr: { xs: 0, sm: 0.5 } }} />
                    {/* Hide text on mobile */}
                    <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
                      Cards
                    </Box>
                  </ToggleButton>

                  <ToggleButton
                    value="table"
                    sx={{
                      px: { xs: 1, sm: 2 },
                      textTransform: "none",
                      fontSize: { xs: 11, sm: 13 },
                    }}
                  >
                    <ViewListIcon fontSize="small" sx={{ mr: { xs: 0, sm: 0.5 } }} />
                    <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
                      Table
                    </Box>
                  </ToggleButton>
                </ToggleButtonGroup>

                <IconButton
                  onClick={onRefresh}
                  disabled={refreshing}
                  size="small"
                  sx={{ p: { xs: 0.5, sm: 1 } }}
                >
                  <RefreshIcon fontSize="small" />
                </IconButton>
              </Box>
            </Box>
          </Container>
        </Paper>
            



      {/* Bookings List */}
      <Container maxWidth="xl" sx={{ py: 3 }}>
        {bookings.length === 0 ? (
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: 10 }}>
            <Typography sx={{ fontSize: 64, mb: 2 }}>📋</Typography>
            <Typography sx={{ fontSize: 20, fontWeight: 700, color: "#111827", mb: 1 }}>
              No Bookings Found
            </Typography>
            <Typography sx={{ fontSize: 14, color: "#6B7280", textAlign: "center", mb: 3 }}>
              Your booked services will appear here
            </Typography>
          </Box>
        ) : bookingViewMode === 'card' ? (
          <Grid container spacing={3}>
            {bookings.filter(b => b.status !== "cancelled").map((booking) => (
              <Grid item xs={12} md={6} key={booking.booking_id}>
                {renderBookingCard(booking)}
              </Grid>
            ))}
          </Grid>
        ) : (
          renderBookingTable()
        )}
      </Container>

      {/* Dialog for Feedback/Complaint/Reschedule/Cancel */}
      <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 4 } }}>
        <DialogTitle sx={{ fontSize: 20, fontWeight: 700, color: "#006D77", borderBottom: "1px solid #F3F4F6", textAlign: "center" }}>
          {dialogType === "complaint" && "📝 Raise Complaint"}
          {dialogType === "feedback" && "⭐ Service Feedback"}
          {dialogType === "reschedule" && "🔄 Reschedule Booking"}
          {dialogType === "cancel" && "❌ Cancel Booking"}
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          {dialogType === "feedback" && (
            <Box>
              <Typography sx={{ mb: 2, fontWeight: 600 }}>How was your experience?</Typography>
              <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                <Rating
                  value={formData.rating}
                  size="large"
                  onChange={(e, newValue) => setFormData({ ...formData, rating: newValue })}
                />
              </Box>
              <TextField
                label="Share your feedback"
                fullWidth
                multiline
                rows={4}
                value={formData.comment}
                onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
              />
            </Box>
          )}

          {dialogType === "complaint" && (
            <Box>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Category</InputLabel>
                <Select
                  value={formData.category}
                  onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                  label="Category"
                >
                  <MenuItem value="service delay">Service Delay</MenuItem>
                  <MenuItem value="staff issue">Staff Issue</MenuItem>
                  <MenuItem value="quality issue">Quality Issue</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                </Select>
              </FormControl>
              <TextField
                label="Describe your complaint"
                fullWidth
                multiline
                rows={4}
                value={formData.comment}
                onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
              />
            </Box>
          )}

          {dialogType === "reschedule" && (
            <Box>
              <Typography sx={{ mb: 2, fontWeight: 600 }}>
                Service: {selectedBooking?.service_type}
              </Typography>
              <TextField
                label="Select New Date & Time"
                type="datetime-local"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={convertOffsetISOToLocalInput(formData.date)}
                // onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                onChange={(e) => {
                  const value = e.target.value; // "2026-02-28T15:05"
                  if (!value) return;

                  const offset = new Date().getTimezoneOffset();
                  const sign = offset <= 0 ? "+" : "-";
                  const absOffset = Math.abs(offset);
                  const hours = String(Math.floor(absOffset / 60)).padStart(2, "0");
                  const minutes = String(absOffset % 60).padStart(2, "0");

                  const formatted = `${value}:00${sign}${hours}:${minutes}`;
                console.log(formatted)
                  setFormData({ ...formData, date: formatted });}}
                inputProps={{
                  min: minDateTime,
                  max: maxDateTime
                }}
                sx={{ mb: 2 }}
              />
                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  label="Reason for Reschedule"
                  value={formData.reschedule_reason}
                  onChange={(e) =>
                    setFormData({ ...formData, reschedule_reason: e.target.value })
                  }
                  placeholder="Eg: Patient not available, requested different time"
                  sx={{ mt: 2 }}
                />

            </Box>
          )}

          {dialogType === "cancel" && (
            <Box sx={{ textAlign: "center", py: 2 }}>
              <Typography sx={{ fontSize: 18, fontWeight: 600, color: "#DC2626", mb: 2 }}>
                ⚠️ Are you sure you want to cancel this booking?
              </Typography>
              <TextField
                label="Cancellation Reason"
                multiline
                required
                rows={3}
                fullWidth
                value={formData.cancellation_reason || ""}
                onChange={(e) =>
                  setFormData({ ...formData, cancellation_reason: e.target.value })
                }
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2.5, borderTop: "1px solid #F3F4F6" }}>
          <Button onClick={handleCloseDialog} sx={{ color: "#6B7280", textTransform: "none" }}>
            Close
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
            sx={{
              bgcolor: dialogType === "cancel" ? "#DC2626" : "#006D77",
              textTransform: "none",
              minWidth: 120,
              "&:hover": { bgcolor: dialogType === "cancel" ? "#B91C1C" : "#005A63" },
            }}
          >
            {loading ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : dialogType === "cancel" ? "Yes, Cancel" : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Preview Dialog */}
      <Dialog
        open={previewDialog.open}
        onClose={handleClosePreview}
        maxWidth="lg"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle sx={{ bgcolor: "#006D77", color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <DescriptionIcon />
            <Typography variant="h6">Report Preview</Typography>
          </Box>
          <IconButton onClick={handleClosePreview} sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          {previewDialog.url && (
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h6" fontWeight="600" gutterBottom>
                {previewDialog.filename}
              </Typography>
              
              {isImageFile(previewDialog.type) ? (
                <img 
                  src={previewDialog.url} 
                  alt={previewDialog.filename}
                  style={{ 
                    maxWidth: '100%', 
                    maxHeight: '600px',
                    borderRadius: '8px',
                    border: '2px solid #E5E7EB'
                  }}
                />
              ) : previewDialog.type === 'pdf' ? (
                <iframe
                  src={previewDialog.url}
                  style={{
                    width: '100%',
                    height: '600px',
                    border: '2px solid #E5E7EB',
                    borderRadius: '8px'
                  }}
                  title="PDF Preview"
                />
              ) : (
                <Paper sx={{ p: 4, bgcolor: "#F9FAFB" }}>
                  <DescriptionIcon sx={{ fontSize: 64, color: "grey.400", mb: 2 }} />
                  <Typography variant="body1" color="text.secondary">
                    Preview not available for this file type
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Please download the file to view it
                  </Typography>
                </Paper>
              )}
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {/* Validation Dialog */}
      <Dialog open={validationDialogOpen} onClose={() => setValidationDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogContent sx={{ textAlign: "center", py: 4 }}>
          <Typography sx={{ fontSize: 48, mb: 2 }}>
            {validationMessage.includes("success") || validationMessage.includes("Success") ? "✅" : "ℹ️"}
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 600, color: "#111827" }}>
            {validationMessage}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
          <Button
            variant="contained"
            onClick={() => setValidationDialogOpen(false)}
            sx={{
              bgcolor: "#006D77",
              textTransform: "none",
              px: 4,
              "&:hover": { bgcolor: "#005A63" }
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>


{/*  ADD ISSUES DIALOG - PLACE BEFORE </Box> AND AFTER VALIDATION DIALOG */}
<Dialog
  open={issuesDialog.open}
  onClose={() => {
    setIssuesDialog({ open: false, booking: null });
    setExpandedIssues({});
  }}
  maxWidth="md"
  fullWidth
  PaperProps={{ sx: { borderRadius: 3 } }}
>
  <DialogTitle 
    sx={{ bgcolor: "#006D77", color: "white", display: "flex", justifyContent: "space-between", alignItems: "center",py: 2 }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
      <Box
        sx={{bgcolor: 'white',borderRadius: '50%',width: 36,height: 36,display: 'flex',alignItems: 'center',justifyContent: 'center' }}
      >
        <Typography sx={{ fontSize: 20 }}>⚠️</Typography>
      </Box>
      <Box>
        <Typography variant="h6" fontWeight="700">
          Issues & Failures
        </Typography>
        <Typography variant="caption" sx={{ opacity: 0.9 }}>
          Booking ID: #{issuesDialog.booking?.booking_id}
        </Typography>
      </Box>
    </Box>
    <IconButton 
      onClick={() => {
        setIssuesDialog({ open: false, booking: null });
        setExpandedIssues({});
      }} 
      sx={{ color: "white" }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent sx={{ p: 3, bgcolor: '#F9FAFB' }}>
    {issuesDialog.booking && (() => {
      const combinedIssues = getCombinedIssues(issuesDialog.booking);
      
      if (combinedIssues.length === 0) {
        return (
          <Box sx={{ textAlign: 'center', py: 6 }}>
            <Typography sx={{ fontSize: 48, mb: 2 }}>✅</Typography>
            <Typography variant="h6" fontWeight="600" color="text.secondary">
              No Issues Found
            </Typography>
            <Typography variant="body2" color="text.secondary">
              This booking has no reported issues or failures
            </Typography>
          </Box>
        );
      }

      return (
        <Box>
          {/* Summary Chips */}
          <Box sx={{ display: 'flex', gap: 1, mb: 3, justifyContent: 'center',marginTop:4 }}>
            <Chip 
              label={`${combinedIssues.filter(i => i.source === 'delivery_issue').length} Delivery Issues`}
              sx={{ bgcolor: '#DBEAFE',color: '#1E40AF',fontWeight: 600,fontSize: 12,pointerEvents: 'none'}}
            />
            <Chip 
              label={`${combinedIssues.filter(i => i.source === 'collection_failure').length} Collection Failures`}
              sx={{ bgcolor: '#DBEAFE',color: '#1E40AF',fontWeight: 600,fontSize: 12,pointerEvents: 'none',}}
            />
          </Box>

          {/* Issues List */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {combinedIssues.map((issue, index) => {
              const isExpanded = expandedIssues[issue.issue_id] || false;
              const issueTypeFormatted = issue.issue_type?.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase()) || 'N/A';
              const isCollectionFailure = issue.source === 'collection_failure';
              
              return (
                <Card 
                  key={issue.issue_id || index}
                  elevation={2}
                  sx={{ border: '2px solid #E5E7EB',bgcolor: 'white',overflow: 'hidden'}}
                >
                  {/* Issue Header */}
                  <Box
                    onClick={() => setExpandedIssues(prev => ({ ...prev, [issue.issue_id]: !isExpanded }))}
                    sx={{ p: 2,  display: 'flex',  justifyContent: 'space-between',  alignItems: 'center', cursor: 'pointer',
                      bgcolor: issue.status === 'open' ? (isCollectionFailure ? '#EFF6FF' : '#FEF2F2') : 'white',transition: 'all 0.2s',
                      '&:hover': { bgcolor: isCollectionFailure ? '#DBEAFE' : '#FEE2E2'}
                    }}
                  >
                    <Box sx={{ flex: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5, flexWrap: 'wrap' }}>
                        {/* Status Dot */}
                        <Box sx={{width: 8,height: 8,borderRadius: '50%',bgcolor:  '#006D77',boxShadow: `0 0 0 3px ${'#D1EEF0'}`}}/>
                        
                        <Typography variant="body2" fontWeight="700" color="#111827">
                          {issue.issue_id}
                        </Typography>
                        
                        <Chip 
                          label={issue.issue_category}
                          size="small"
                          sx={{ 
                            bgcolor: isCollectionFailure ? '#DBEAFE' : '#FEE2E2',
                            color: isCollectionFailure ? '#1E40AF' : '#991B1B',fontWeight: 600,fontSize: 11,height: 22,pointerEvents: 'none'}}
                        />
                        
                        <Chip 
                          label={issueTypeFormatted}
                          size="small"
                          sx={{ bgcolor: '#F3F4F6',color: '#374151',fontWeight: 600,fontSize: 11,height: 22,pointerEvents: 'none'}}
                        />
                        
                        <Chip 
                          label={issue.status === 'resolved' ? 'Resolved' : issue.status === 'in_progress' ? 'In Progress' : 'Open'}
                          size="small"
                          color={
                            issue.status === 'resolved' ? 'success' :
                            issue.status === 'in_progress' ? 'warning' :
                            'error'
                          }
                          sx={{ fontWeight: 600,fontSize: 11,height: 22,pointerEvents: 'none'}}
                        />
                      </Box>
                      <Typography variant="caption" color="text.secondary" sx={{ fontSize: 11 }}>
                        Reported {formatDate(issue.reported_at)} • By {issue.reported_by || 'Unknown'}
                      </Typography>
                    </Box>

                    <IconButton size="small">
                      <Box
                        sx={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s', fontSize: 20, fontWeight: 'bold', color: '#64748B'}}
                      >
                        ▼
                      </Box>
                    </IconButton>
                  </Box>

                  {/* Expandable Details */}
                  {isExpanded && (
                    <Box sx={{ p: 3, pt: 0, borderTop: '2px solid #E5E7EB', bgcolor: '#F9FAFB' }}>
                      <Grid container spacing={2}>
                        {/* Description */}
                        <Grid item xs={12}>
                          <Typography variant="caption" color="text.secondary" fontWeight="700" sx={{ fontSize: 11, display: 'block', mb: 0.5 }}>
                            {isCollectionFailure ? 'Failure Details' : 'Issue Description'}
                          </Typography>
                          <Paper variant="outlined" sx={{ p: 2, bgcolor: 'white' }}>
                            <Typography variant="body2" color="#4B5563" sx={{ fontSize: 13 }}>
                              {issue.description || 'No description provided'}
                            </Typography>
                          </Paper>
                        </Grid>

                        {/* Photo Evidence */}
                        {issue.photo_url && (
                          <Grid item xs={12}>
                            <Typography variant="caption" color="text.secondary" fontWeight="700" sx={{ fontSize: 11, display: 'block', mb: 0.5 }}>
                              Photo Evidence
                            </Typography>
                            <Paper
                              elevation={3}
                              sx={{ overflow: 'hidden', borderRadius: 2, cursor: 'pointer', position: 'relative',
                                '&:hover': { transform: 'scale(1.02)', transition: 'transform 0.3s' }
                              }}
                              onClick={() => window.open(`${process.env.REACT_APP_BACKEND_URL}${issue.photo_url}`, '_blank')}
                            >
                              <Box
                                component="img"
                                src={`${process.env.REACT_APP_BACKEND_URL}${issue.photo_url}`}
                                alt="Issue evidence"
                                sx={{
                                  width: '100%',
                                  height: 250,
                                  objectFit: 'cover'
                                }}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                }}
                              />
                              <Box
                                sx={{position: 'absolute',bottom: 0,left: 0,right: 0,bgcolor: 'rgba(0,0,0,0.7)',color: 'white',p: 1.5,textAlign: 'center' }}
                              >
                                <Typography variant="caption" sx={{ fontSize: 12, fontWeight: 600 }}>
                                  🔍 Click to view full size
                                </Typography>
                              </Box>
                            </Paper>
                          </Grid>
                        )}

                        {/* Collection Failure Specific Info */}
                        {isCollectionFailure && (issue.can_reschedule || issue.patient_available || issue.address_issue) && (
                          <Grid item xs={12}>
                            <Typography variant="caption" color="#2563EB" fontWeight="700" sx={{ fontSize: 11, display: 'block', mb: 0.5 }}>
                              Additional Information
                            </Typography>
                            <Paper variant="outlined" sx={{ bgcolor: '#EFF6FF', borderColor: '#BFDBFE' }}>
                              <Box sx={{ p: 2 }}>
                                {issue.can_reschedule && (
                                  <Typography variant="body2" sx={{ mb: 1 }}>
                                    <strong>Can Reschedule:</strong> {issue.can_reschedule}
                                  </Typography>
                                )}
                                {issue.suggested_reschedule_time && (
                                  <Typography variant="body2" sx={{ mb: 1 }}>
                                    <strong>Suggested Time:</strong> {issue.suggested_reschedule_time}
                                  </Typography>
                                )}
                                {issue.patient_available && (
                                  <Typography variant="body2" sx={{ mb: 1 }}>
                                    <strong>Patient Available:</strong> {issue.patient_available}
                                  </Typography>
                                )}
                                {issue.address_issue && (
                                  <Typography variant="body2" sx={{ mb: 1 }}>
                                    <strong>Address Issue:</strong> {issue.address_issue}
                                  </Typography>
                                )}
                                {issue.additional_notes && (
                                  <Typography variant="body2">
                                    <strong>Notes:</strong> {issue.additional_notes}
                                  </Typography>
                                )}
                              </Box>
                            </Paper>
                          </Grid>
                        )}

                        {/* Resolution (if resolved) */}
                        {issue.status === 'resolved' && issue.resolution && (
                          <Grid item xs={12}>
                            <Typography variant="caption" color="#059669" fontWeight="700" sx={{ fontSize: 11, display: 'block', mb: 0.5 }}>
                              ✅ Resolution
                            </Typography>
                            <Paper 
                              variant="outlined"
                              sx={{  p: 2,  bgcolor: '#F0FDF4', borderColor: '#86EFAC'}}
                            >
                              <Typography variant="body2" color="#166534" sx={{ fontSize: 13 }}>
                                {issue.resolution}
                              </Typography>
                              {issue.resolved_by && issue.resolved_at && (
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, fontSize: 11 }}>
                                  Resolved by {issue.resolved_by} on {formatDate(issue.resolved_at)}
                                </Typography>
                              )}
                            </Paper>
                          </Grid>
                        )}
                      </Grid>
                    </Box>
                  )}
                </Card>
              );
            })}
          </Box>
        </Box>
      );
    })()}
  </DialogContent>

  <DialogActions sx={{ p: 2.5, borderTop: "1px solid #E5E7EB", bgcolor: '#F9FAFB' }}>
    <Button
      variant="contained"
      onClick={() => {
        setIssuesDialog({ open: false, booking: null });
        setExpandedIssues({});
      }}
      sx={{bgcolor: "#006D77",textTransform: "none",px: 4,fontWeight: 600,"&:hover": { bgcolor: "#005761" }}}
    >
      Close
    </Button>
  </DialogActions>
</Dialog>

    </Box>
          <Footer />
      <CustomDialog
        open={validationDialogOpen}
        message={validationMessage}
        onClose={() => setValidationDialogOpen(false)}
      />
      </>
  );
};

export default MyBookingsScreen;